module.exports = __webpack_public_path__ + "static/media/jack_club.3e344f33.png";